import { render, staticRenderFns } from "./LeadDesktopServicePromotion.vue?vue&type=template&id=0853de36&scoped=true&"
import script from "./LeadDesktopServicePromotion.vue?vue&type=script&lang=js&"
export * from "./LeadDesktopServicePromotion.vue?vue&type=script&lang=js&"
import style0 from "./LeadDesktopServicePromotion.vue?vue&type=style&index=0&id=0853de36&scoped=true&lang=css&"
import style1 from "./LeadDesktopServicePromotion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0853de36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0853de36')) {
      api.createRecord('0853de36', component.options)
    } else {
      api.reload('0853de36', component.options)
    }
    module.hot.accept("./LeadDesktopServicePromotion.vue?vue&type=template&id=0853de36&scoped=true&", function () {
      api.rerender('0853de36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/ServicePromotion/LeadDesktopServicePromotion.vue"
export default component.exports